import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, ReplaySubject, retry, tap, throwError } from 'rxjs';
 
 
import { AuthService } from '../auth/auth.service';
import { ICustomer } from './shared-interface.types';
import { WebStorage } from './web.storage';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CustomerService
{
    private _customer: ReplaySubject<ICustomer> = new ReplaySubject<ICustomer>(1);

    private proxyUrl: string

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _webStorage: WebStorage, private _authService: AuthService)
    {
        this.proxyUrl = environment.baseUrl;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for customer
     *
     * @param value
     */
    set customer(value: ICustomer)
    {
        // Store the value
        this._customer.next(value);
        this._webStorage.setCustomerName(value.FirstName)
    }

    get customer$(): Observable<ICustomer>
    {
        return this.get();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in customer data
     */
    get(): Observable<ICustomer>
    {
        return this._httpClient.get<ICustomer>(`${this.proxyUrl}/service?url=auth/validate`)
        .pipe(
            tap((customer) => {
                this._customer.next(customer);                
                this._webStorage.setCustomerName(customer.FirstName)
            }),
            retry(2),
            catchError(error => {
                console.error(error);
                if(error.status == 500) {
                    this._authService.signOut();
                }
                return throwError(error);
              })
        );
    }

    /**
     * Update the customer
     *
     * @param customer
     */
    update(customer: ICustomer): Observable<any>
    {
        return this._httpClient.patch<ICustomer>('api/common/user', {customer}).pipe(
            map((response) => {
                this._customer.next(response);
                this._webStorage.setCustomerName(customer.FirstName)
            })
        );
    }

    /**
     * verify the customers email
     *
     * @param customer
     */
    verifyEmail(token: string): Observable<any>
    {
        return this._httpClient.get<ICustomer>(`${this.proxyUrl}/service?url=endcustomer/verifyemailaddress` + '?token=' + token);
    }
}
